import styled, { css } from 'styled-components';
import { ReactComponent as EllipsisStrokeSvg } from '../assets/icons/fal-ellipsis-stroke.svg';
import { ReactComponent as ChartAreaSvg } from '../assets/icons/fal-chart-area.svg';
import { ReactComponent as ObjectGroupSvg } from '../assets/icons/fal-object-group.svg';
import { ReactComponent as RobotSvg } from '../assets/icons/fal-robot.svg';
import { ReactComponent as CircleExclamationSvg } from '../assets/icons/fal-circle-exclamation.svg';

const iconStyle = css`
  width: 18px;
  height: auto;
  fill: ${({theme}) => theme.colors.text_dark};
`;

const ProfileGroundIcon = styled(EllipsisStrokeSvg)`
  ${iconStyle};
`;

const ProfileLineIcon = styled(ChartAreaSvg)`
  ${iconStyle};
`;

const AreaIcon = styled(ObjectGroupSvg)`
  ${iconStyle};
`;

const ProfileAiIcon = styled(RobotSvg)`
  ${iconStyle};
`;

const ErrorIcon = styled(CircleExclamationSvg)`
  ${iconStyle};
  fill: ${({theme}) => theme.colors.negative};
`;

export const getFeatureTypeIcon = ({featureType, profileType}) => {

  if(featureType === 'Polygon') {
    return <AreaIcon data-tip="Area"/>;
  }

  if(featureType === 'LineString') {

    if(profileType === 0) {
      return <ProfileGroundIcon data-tip="Profile"/>;
    }

    if(profileType === 2) {
      return <ProfileLineIcon data-tip="Profile"/>;
    }

    if(profileType === 3) {
      return <ProfileAiIcon data-tip="AI detection"/>;
    }
  }

  return <ErrorIcon data-tip="Error"/>;
}